import { render, staticRenderFns } from "./MultipleModal.vue?vue&type=template&id=b21dcdec&scoped=true"
import script from "./MultipleModal.vue?vue&type=script&lang=ts"
export * from "./MultipleModal.vue?vue&type=script&lang=ts"
import style0 from "./MultipleModal.vue?vue&type=style&index=0&id=b21dcdec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21dcdec",
  null
  
)

export default component.exports